<template>
	<v-row class="ma-0">
		<v-col :cols="$vuetify.breakpoint.xsOnly ? 12 : colsNumber" :class="$vuetify.breakpoint.xsOnly ? 'px-0':styleLeft">
			<v-row class="ma-0" :justify="is_lock ? 'space-between':'start'">
				<div class="item-text" :class="[disabled ? `text-disable`:`text-able`, startError || errorStartFlag ? 'text-error':'text-ok']">{{ startText }}</div>
				<v-icon v-if="is_lock" small>mdi-lock-outline</v-icon>
			</v-row>
			<v-menu
				v-if="$vuetify.breakpoint.xsOnly"
				ref="menu_start_time"
				v-model="menu_start_time"
				:close-on-content-click="false"
				transition="scale-transition"
				offset-y
				nudge-left="4px"
				max-width="280px"
				min-width="280px"
				:disabled="disabled"
			>
				<template v-slot:activator="{ on, attrs }">
					<v-text-field
						v-model="time_start"
						:color="color"
						:background-color="background"
						v-bind="attrs"
						v-on="on"
						outlined
						dense
						readonly
						hide-details
						min-width="auto"
					>
					</v-text-field>
				</template>
				<v-time-picker
					v-if="menu_start_time"
					key="menu_start_time"
					:value="formatTimePicker(time_start)"
					:color="color"
					full-width
					ampm-in-title
					scrollable
					@input="onStartTimeChange($event)"
				></v-time-picker>
			</v-menu>
			<v-text-field
				v-if="!$vuetify.breakpoint.xsOnly"
				v-model="time_start"
				:id="`${refId}`"
				:ref="`input-${refId}`"
				:color="color"
				:rules="time_rules"
				:error="startError || errorStartFlag"
				:disabled="disabled"
				:background-color="background"
				outlined
				dense
				hide-details
				min-width="auto"
				@change="onStartTimeChange($event)"
			>
			</v-text-field>
			<div v-if="startError" class="optional-text-red">{{ startErrorText }}</div>
			<div v-if="isOptional" class="optional-text">optional</div>
		</v-col>
		<v-col :cols="$vuetify.breakpoint.xsOnly ? 12 : colsNumber" :class="$vuetify.breakpoint.xsOnly ? 'px-0':styleRight">
			<v-row class="ma-0" :justify="is_lock ? 'space-between':'start'">
				<div class="item-text" :class="[disabled ? `text-disable`:`text-able`, endError || errorEndFlag ? 'text-error':'text-ok']">{{ endText }}</div>
				<v-icon v-if="is_lock" small>mdi-lock-outline</v-icon>
			</v-row>
			<v-menu
				v-if="$vuetify.breakpoint.xsOnly"
				ref="menu_end_time"
				v-model="menu_end_time"
				:close-on-content-click="false"
				transition="scale-transition"
				offset-y
				nudge-left="4px"
				max-width="280px"
				min-width="280px"
				:disabled="disabled"
			>
				<template v-slot:activator="{ on, attrs }">
					<v-text-field
						v-model="time_end"
						:color="color"
						:background-color="background"
						v-bind="attrs"
						v-on="on"
						outlined
						hide-details
						dense
						readonly
						min-width="auto"
					>
					</v-text-field>
				</template>
				<v-time-picker
					key="menu_end_time"
					v-if="menu_end_time"
					:value="formatTimePicker(time_end)"
					:color="color"
					full-width
					ampm-in-title
					scrollable
					@input="onEndTimeChange($event)"
				></v-time-picker>
			</v-menu>
			<v-text-field
				v-if="!$vuetify.breakpoint.xsOnly"
				v-model="time_end"
				:id="`${refId + 1}`"
				:ref="`input-${refId + 1}`"
				:color="color"
				:rules="time_rules"
				:error="endError || errorEndFlag || timeOverage"
				:disabled="disabled"
				:background-color="background"
				outlined
				dense
				hide-details
				min-width="auto"
				@change="onEndTimeChange($event)"
				@keydown="onKeydown($event)"
			>
			</v-text-field>
			<div v-if="endError" class="optional-text-red">{{ endErrorText }}</div>
			<div v-if="timeOverage" class="optional-text-red">{{ timeOverageText }}</div>
			<div v-if="isOptional" class="optional-text">optional</div>
		</v-col>
	</v-row>
</template>
<script>
import { validTime } from "@/common/validTime.js";
import { validHour } from "@/common/validHour.js";
import { budgetToMinutes, minutesToBudget } from "@/common/budgetToMinute.js";

import moment from 'moment';
import config from "@/config.js";

const TIME_REG = config.time_reg;
const TIME_SUFFIX_REG = config.time_suffix_reg;
const TIME_A_REG = config.time_a_reg;
const TIME_AM_REG = config.time_am_reg;
const TIME_ALL_REG = config.time_all_reg;
const TIME_ALL_A_REG = config.time_all_a_reg;
const TIME_ALL_AM_REG = config.time_all_am_reg;


export default {
	name: 'DateTime',
	props: {
		refId: {
			type: Number,
			default: 0
		},
		startTimeInit: {
			type: String,
			default: ''
		},
		endTimeInit: {
			type: String,
			default: ''
		},
		startText: {
			type: String,
			default: 'Start time'
		},
		endText: {
			type: String,
			default: 'End time'
		},
		color: {
			type: String,
			default: ''
		},
		colsNumber: {
			type: Number,
			default: 6
		},
		duration: {
			type: String,
			default: ''
		},
		timeOverage: {
			type: Boolean,
			default: false
		},
		background: {
			type: String,
			default: '#FAFAFA'
		},
		isOptional: {
			type: Boolean,
			default: false
		},
		disabled: {
			type: Boolean,
			default: false
		},
		startError: {
			type: Boolean,
			default: false
		},
		errorStartFlag: {
			type: Boolean,
			default: false
		},
		endError: {
			type: Boolean,
			default: false
		},
		errorEndFlag: {
			type: Boolean,
			default: false
		},
		startErrorText: {
			type: String,
			default: 'End time must be later than Start time'
		},
		endErrorText: {
			type: String,
			default: 'End time must be later than Start time'
		},
		timeOverageText: {
			type: String,
			default: 'not beyond 11:59 pm on the same day'
		},
		styleLeft : {
			type: String,
			default: ''
		},
		styleRight : {
			type: String,
			default: ''
		},
		is_lock: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			menu_start_time: false,
			menu_end_time: false,
			time_start: this.startTimeInit && this.startTimeInit.length !== 0 ? this.startTimeInit : null,
			time_end: this.endTimeInit && this.endTimeInit.length !== 0 ? this.endTimeInit : null,

			time_rules: [
				value => {
					return validTime(value);
				}
			],
		}
	},
	components: {
	},
	watch: {
		duration() {
			if (validHour(this.duration) && (this.duration.includes('m') || this.duration.includes('h'))) {
				const duration_minute = budgetToMinutes(this.duration);
				const duration_budget = minutesToBudget(duration_minute);

				const time_start = this.time_start ? this.time_start : '0';
				let time_start_tmp = time_start.replace(/\s+/g,"");

				const time_end = this.time_end ? this.time_end : '0';
				let time_end_tmp = time_end.replace(/\s+/g,"");

				if (duration_budget.length !== 0 && validTime(time_start_tmp) && !validTime(time_end_tmp)) {
					const mins = budgetToMinutes(duration_budget);
					const start = moment(time_start_tmp, 'HH:mma');
					const end = start.add(mins, 'minutes').format('h:mm a');
					this.time_end = end;
					this.$emit('time_end', this.time_end);
				} else if (duration_budget.length !== 0 && !validTime(time_start_tmp) && validTime(time_end_tmp)) {
					const mins = budgetToMinutes(duration_budget);
					const end = moment(time_end_tmp, 'HH:mma');
					const start = end.subtract(mins, 'minutes').format('h:mm a');
					this.time_start = start;
					this.$emit('time_start', this.time_start);
				} else if (duration_budget.length !== 0 && validTime(time_start_tmp) && validTime(time_end_tmp)) {
					const mins = budgetToMinutes(duration_budget);
					const start = moment(time_start_tmp, 'HH:mma');
					const end = start.add(mins, 'minutes').format('h:mm a');
					this.time_end = end;
					this.$emit('time_end', this.time_end);
				}
			}
		},
		startTimeInit() {
			if (this.startTimeInit !== null) {
				this.time_start = this.startTimeInit;
			}
		},
		endTimeInit() {
			if (this.endTimeInit !== null) {
				this.time_end = this.endTimeInit;
			}
		}
	},
	methods: {
		formatTimePicker(time) {
			let time_tmp = null;

			if (time) {
				time_tmp = time.replace(/\s+/g,"");
				time_tmp = this._formatTime(time_tmp);
			}

			return time_tmp
		},
		onStartTimeChange(time) {
			let time_tmp = time.replace(/\s+/g,"");

			if (time_tmp.length === 0) {
				this.time_start = null;
				this.$emit('time_start', this.time_start);
			} else {
				if (validTime(time_tmp)) {
					const time_24h = this._formatTime(time_tmp);

					if (moment(time_tmp, 'HH:mm').isValid() && time_tmp.startsWith('0') && (time_tmp.indexOf(':') !== -1)) {
						/** e.g., 05:00 */
						const time_12h = moment(time_24h, 'HH:mm').format('h:mm a');
						this.time_start = time_12h;

					} else {
						if (time_tmp.includes('a') || time_tmp.includes('p')) {
							const time_12h = moment(time_24h, 'HH:mm').format('h:mm a');
							this.time_start = time_12h;
						} else {
							if (time_24h < '07:00') {
								const time_arr = time_24h.split(':');
								const over_noon = `${Number(time_arr[0]) + 12}:${time_arr[1]}`;
						
								const time_12h = moment(over_noon, 'HH:mm').format('h:mm a');
								this.time_start = time_12h;
							} else {
								const time_12h = moment(time_24h, 'HH:mm').format('h:mm a');
								this.time_start = time_12h;
							}
						}
					}

					const time_start = this.time_start ? this.time_start: '0';
					let time_start_tmp = time_start.replace(/\s+/g,"");

					const time_end = this.time_end ? this.time_end : '0';
					let time_end_tmp = time_end.replace(/\s+/g,"");

					if (this.duration && this.duration.length !== 0 && validTime(time_start_tmp) && time_end_tmp === '0') {					
						const mins = budgetToMinutes(this.duration);
						const start = moment(time_start_tmp, 'HH:mma');
						const end = start.add(mins, 'minutes').format('h:mm a');
						this.time_end = end;
						this.$emit('time_start', this.time_start);
						this.$emit('time_end', this.time_end);
					} else {
						this.$emit('time_start', this.time_start);
					}				
				}
			}
		},
		onEndTimeChange(time) {
			let time_tmp = time.replace(/\s+/g,"");

			if (time_tmp.length === 0) {
				this.time_end = null;
				this.$emit('time_end', this.time_end);
			} else {
				if (validTime(time_tmp)) {
					const time_24h = this._formatTime(time_tmp);

					if (moment(time_tmp, 'HH:mm').isValid() && time_tmp.startsWith('0') && (time_tmp.indexOf(':') !== -1)) {
						const time_12h = moment(time_24h, 'HH:mm').format('h:mm a');
						this.time_end = time_12h;
					
					} else {
						if (time_tmp.includes('a') || time_tmp.includes('p')) {
							const time_12h = moment(time_24h, 'HH:mm').format('h:mm a');
							this.time_end = time_12h;
						} else {
							if (time_24h < '07:00') {
								const time_arr = time_24h.split(':');
								const over_noon = `${Number(time_arr[0]) + 12}:${time_arr[1]}`;

								const time_12h = moment(over_noon, 'HH:mm').format('h:mm a');
								this.time_end = time_12h;
							} else {
								if (this.time_start && this.time_start.indexOf('pm') !== -1 && time_24h < '12:00') {
									const time_arr = time_24h.split(':');
									const over_noon = `${Number(time_arr[0]) + 12}:${time_arr[1]}`;

									const time_12h = moment(over_noon, 'HH:mm').format('h:mm a');
									this.time_end = time_12h;
								} else {
									const time_12h = moment(time_24h, 'HH:mm').format('h:mm a');
									this.time_end = time_12h;
								}
							}
						}
					}

					const time_start = this.time_start ? this.time_start : '0';
					let time_start_tmp = time_start.replace(/\s+/g,"");
			
					const time_end = this.time_end ? this.time_end : '0';
					let time_end_tmp = time_end.replace(/\s+/g,"");

					if (this.duration && this.duration.length !== 0 && validTime(time_end_tmp) && time_start_tmp === '0') {
						const mins = budgetToMinutes(this.duration);
						const end = moment(time_end_tmp, 'HH:mma');
						const start = end.subtract(mins, 'minutes').format('h:mm a');
						this.time_start = start;

						this.$emit('time_start', this.time_start);
						this.$emit('time_end', this.time_end);
					} else {
						this.$emit('time_end', this.time_end);
					}
				}
			}
		},
		onKeydown($event) {
			this.$emit('keydown', $event)
		},
		_formatTime(time) {
			let result = 0;
			
			if (TIME_REG.test(time)) {
				const time_tmp = `${time}:00`;
				result = moment(time_tmp, ['H:m', 'H:mm', 'HH:m', 'HH:mm']).format('HH:mm');
			}

			if (TIME_SUFFIX_REG.test(time)) {
				const split_str = time.includes('.') ? '.':':';
				const time_tmp = time.split(split_str);
				const result_tmp = `${time_tmp[0]}:00`;
				result = moment(result_tmp, ['H:m', 'H:mm', 'HH:m', 'HH:mm']).format('HH:mm');
			}

			if (TIME_A_REG.test(time)) {
				result = moment(time,'Ha','HHa').format('HH:mm');
			}

			if (TIME_AM_REG.test(time)) {
				result = moment(time,'Ha','HHa').format('HH:mm');
			}

			if (TIME_ALL_REG.test(time)) {
				const time_tmp = time.includes('.') ? time.replace('.',':') : time;
				result = moment(time_tmp, ['H:m', 'H:mm', 'HH:m', 'HH:mm']).format('HH:mm');
			}

			if (TIME_ALL_A_REG.test(time)) {
				const time_tmp = time.includes('.') ? time.replace('.',':') : time;
				result = moment(time_tmp, ['H:ma', 'H:mma', 'HH:ma', 'HH:mma']).format('HH:mm');
			}

			if (TIME_ALL_AM_REG.test(time)) {
				const time_tmp = time.includes('.') ? time.replace('.',':') : time;
				result = moment(time_tmp, ['H:ma', 'H:mma', 'HH:ma', 'HH:mma']).format('HH:mm');
			}

			return result;
		},
	}
}
</script>

<style lang="scss" scoped>
.item-text {
	font-family: 'Roboto';
	font-style: normal;
	font-weight: 400;
	font-size: 14px;
	line-height: 20px;
	letter-spacing: 0.25px;
}
.text-able {
	opacity: 0.87;
}
.text-disable {
	opacity: 0.4;
}
.text-ok {
  color: #37495F;
}
.text-error {
	color: #F45252;
}
.optional-text {
	font-family: Roboto;
	font-style: normal;
	font-weight: normal;
	font-size: 12px;
	line-height: 20px;

	text-align: right;
	letter-spacing: 0.4px;
	color: #37495F;
}
.optional-text-red {
	font-family: Roboto;
	font-style: normal;
	font-weight: normal;
	font-size: 12px;

	color: #F45252;
}
</style>
